// components/AnswerCard.js
import React, { Component } from "react";
import axios from "axios"; // For API calls
const config = require("../config.json"); // Adjust path

export default class AnswerCard extends Component {
  state = {
    currentUpvoteCount: this.props.answer.upvoteCount || 0,
    isUpvotedByCurrentUser: false, // This is tricky to manage without knowing current user & their upvotes
    upvoteLoading: false,
    upvoteError: null,
  };

  // TODO: In a real app, you'd need to know the current logged-in user's ID
  // and potentially fetch if they've already upvoted this answer.
  // For admin testing, we can simplify or assume a test user ID.
  LOGGED_IN_TEST_USER_ID = "admin_panel_upvoter"; // Example

  handleUpvote = async () => {
    if (this.state.upvoteLoading) return;

    this.setState({ upvoteLoading: true, upvoteError: null });
    const { answer } = this.props;

    try {
      await axios.post(
        `${config.api.invokeUrl}/messageboard/answers/${answer.answerId}/upvote`,
        {
          userId: this.LOGGED_IN_TEST_USER_ID,
          answerSk: answer.sk,
          answerPk: answer.pk,
        } // Send the user ID doing the upvoting
      );

      this.setState((prevState) => ({
        currentUpvoteCount: prevState.currentUpvoteCount + 1,
        isUpvotedByCurrentUser: true, // Optimistic update
        upvoteLoading: false,
      }));
      // Optionally, inform parent or refresh feed if necessary
    } catch (error) {
      console.error(`Error upvoting answer ${answer.answerId}:`, error);
      let errorMessage = `Failed to upvote: ${error.message}`;
      if (error.response?.data?.message) {
        errorMessage = error.response.data.message;
        if (error.response.status === 409) {
          // Conflict - already upvoted
          this.setState({ isUpvotedByCurrentUser: true }); // Correct the state
        }
      }
      this.setState({ upvoteError: errorMessage, upvoteLoading: false });
    }
  };

  render() {
    const { answer } = this.props;
    const {
      currentUpvoteCount,
      isUpvotedByCurrentUser,
      upvoteLoading,
      upvoteError,
    } = this.state;

    if (!answer) return null;
    const formattedDate = answer.createdAt
      ? new Date(answer.createdAt).toLocaleDateString()
      : "N/A";

    return (
      <div className="card mb-4">
        <div className="card-content">
          <div className="content">
            <p className="is-size-7 has-text-grey">
              Question (ID: {answer.questionCommonId}, Lang:{" "}
              {answer.questionLanguageCode}):
            </p>
            <p className="title is-6 has-text-link mb-2">
              {answer.questionTitle || "Question title not available"}
            </p>
            <hr className="mt-1 mb-3" />
            <p>{answer.answerText}</p>
            <br />
            <p className="is-size-7 has-text-grey-light">
              By: {answer.username || answer.userId || "Unknown User"} on{" "}
              {formattedDate}
            </p>
            {upvoteError && (
              <p className="help is-danger mt-1">{upvoteError}</p>
            )}
            <div className="level is-mobile mt-3">
              <div className="level-left">
                <div className="level-item">
                  <span className="icon-text">
                    <span>{currentUpvoteCount} Upvotes</span>
                  </span>
                </div>
              </div>
              <div className="level-right">
                <div className="level-item">
                  <button
                    className={`button is-small ${
                      isUpvotedByCurrentUser ? "is-success" : "is-light"
                    }`}
                    onClick={this.handleUpvote}
                    disabled={upvoteLoading || isUpvotedByCurrentUser}
                    title={
                      isUpvotedByCurrentUser ? "Already Upvoted" : "Upvote"
                    }
                  >
                    {upvoteLoading
                      ? "Voting..."
                      : isUpvotedByCurrentUser
                      ? "Upvoted"
                      : "Upvote (Test)"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
